import React from 'react'

const AboutLanding = props => (
  <section id="banner" className="style2">
    <div className="inner">
      <header className="major">
        <h1>About</h1>
      </header>
      <div className="content">
        <p>Sebrene aka Andy aka a huge fuckin nerd</p>
      </div>
    </div>
  </section>
)

export default AboutLanding
